export enum FeeConfigStatusEnum {
  DRAFT = "draft",
  ENABLED = "enabled",
  DISABLED = "disabled",
}

export interface FeeTier {
  upTo?: number;
  feePercent: number;
  minFee?: number;
  maxFee?: number;
}

export interface FeeRule {
  tiers: FeeTier[];
  customerShare?: number;
  cityShare?: number;
}

export interface FeeConfig {
  id: string;
  logicalFeeId: string;
  version?: number;
  name: string;
  status: FeeConfigStatusEnum;
  customerShare: number;
  cityShare: number;
  rules: FeeRule[];
  createdAt: string;
  publishedAt?: string;
  publishedBy?: string;
  disabledAt?: string;
}

export interface CreateFeeConfigInput {
  name: string;
  customerShare: number;
  cityShare: number;
  rules: FeeRule[];
}

export type UpdateFeeConfigInput = Partial<CreateFeeConfigInput>;

export interface FeeRuleBreakdown {
  ruleIndex: number;
  output: number;
  customerShare: number;
}

export interface FeeBreakdown {
  total: number;
  customerShare: number;
  citySettlement: number;
  perRule: FeeRuleBreakdown[];
}

export interface GroupedFeeConfig {
  logicalFeeId: string;
  current: FeeConfig;
  allVersions: FeeConfig[];
  currentVersions: FeeConfig[];
  previousVersions: FeeConfig[];
}
